import { Injectable } from '@angular/core';

@Injectable()
export class GlobalService {

  private _state = true;

  constructor() { }

  setSearchBoxState(state) {
    this._state = state;
  }

  getSearchBoxState() {
    return this._state;
  }

  getCapGio(tocDoGio: number) {
    if (tocDoGio >= 0 && tocDoGio <= 0.2) {
      return "Lặng";
    }
    else if (tocDoGio >= 0.3 && tocDoGio <= 1.5) {
      return "Gió nhẹ";
    }
    else if (tocDoGio >= 1.6 && tocDoGio <= 3.3) {
      return "Gió nhẹ (Cấp 2)";
    }
    else if (tocDoGio >= 3.4 && tocDoGio <= 5.4) {
      return "Gió nhẹ (Cấp 3)";
    }
    else if (tocDoGio >= 5.5 && tocDoGio <= 7.9) {
      return "Gió cấp 4";
    }
    else if (tocDoGio >= 8 && tocDoGio <= 10.7) {
      return "Gió cấp 5";
    }
    else if (tocDoGio >= 10.8 && tocDoGio <= 13.8) {
      return "Gió cấp 6";
    }
    else if (tocDoGio >= 13.9 && tocDoGio <= 17.1) {
      return "Gió cấp 7";
    }
    else if (tocDoGio >= 17.2 && tocDoGio <= 20.7) {
      return "Gió cấp 8";
    }
    else if (tocDoGio >= 20.8 && tocDoGio <= 24.4) {
      return "Gió cấp 9";
    }
    else if (tocDoGio >= 24.5 && tocDoGio <= 28.4) {
      return "Gió cấp 10";
    }
    else if (tocDoGio >= 28.5 && tocDoGio <= 32.6) {
      return "Gió cấp 11";
    }
    else if (tocDoGio >= 32.7 && tocDoGio <= 36.9) {
      return "Gió cấp 12";
    }
    else if (tocDoGio >= 37 && tocDoGio <= 41.4) {
      return "Gió cấp 13";
    }
    else if (tocDoGio >= 41.5 && tocDoGio <= 46.1) {
      return "Gió cấp 14";
    }
    else if (tocDoGio >= 46.2 && tocDoGio <= 50.9) {
      return "Gió cấp 15";
    }
    else if (tocDoGio >= 51 && tocDoGio <= 56) {
      return "Gió cấp 16";
    }
    else if (tocDoGio >= 56.1 && tocDoGio <= 61.2) {
      return "Gió cấp 17";
    }
    else if (tocDoGio > 61.2) {
      return "Gió cấp > 17";
    }
    return "-";
  }

}
